module.exports = __webpack_public_path__ + "img/bloodchild-and-other-stories.8c35bfd7.png";